import apiClient from './api';

class DashboardService {
  /**
   * Get Dashboard Statistics
   * @returns {Promise} - Dashboard statistics data
   */
  async getStatistics() {
    try {
      const response = await apiClient.get('/admin/dashboard/statistics/');

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Error fetching dashboard statistics:', error);

      let message = 'Failed to fetch dashboard statistics';

      if (error.response) {
        if (error.response.status === 403) {
          message = 'Access denied. Admin privileges required.';
        } else if (error.response.status === 401) {
          message = 'Authentication required. Please log in again.';
        } else if (error.response.data?.detail) {
          message = error.response.data.detail;
        }
      } else if (error.request) {
        message = 'Unable to connect to server. Please check your connection.';
      }

      return {
        success: false,
        error: message,
      };
    }
  }
}

export default new DashboardService();
